import loadable from '@loadable/component';

import AsyncLoader from '../AsyncLoader/AsyncLoader';

export default loadable(() => import('./HeaderRating'), {
  fallback: AsyncLoader(),
});
